export default import.meta.ROLLDOWN_FILE_URL_baAaetsYazQo0z9pNTe1iQ